<div class="row sponsor-container">
    <!-- Sponsor selection section Starts  -->
    <div></div>
    <div  *ngFor="let sponsorSearchOption of sponsorSearchOptions;let i=index;">
        <div class="col-md-5 mb-10" *ngIf="sponsorSearchOption.id === sponsorSearchOptionType.SearchByIKnowSponsor">
            <div class="form-check pl-0">
                <label class="form-check-box" >
                    <input type="radio" #suggestASponsorknow  name="wheredidyouhear" (blur)="focusOnSuggestSponsor()" 
                        [checked]="sponsorWizard === sponsorSearchWizardType.SearchByIKnowSponsor"
                        (click)="setSponsorWizard(  sponsorSearchWizardType.SearchByIKnowSponsor);searchByIDOrNameSponsors ? '' : resetVariable( sponsorSearchWizardType.SearchByIKnowSponsor)">
                    <span class="label-text"></span>
                    <span tabindex="-1" (keyup.control.space)="suggestASponsorknow.click()" role="radio"
                        (keyup.enter)="suggestASponsorknow.click()" class="form-check-text">{{"checkout.I know my sponsor's information" | translate |
            translateKey}}</span>
                    <!-- <span class="form-check-text">{{"common.I know my sponsor's information" |translate | translateKey}}</span> -->
                </label>
            </div>
        </div>
        <div class="col-md-7 mb-10" *ngIf="sponsorSearchOption.id === sponsorSearchOptionType.SearchByIDontHaveSponsor">
            <div class="form-check pl-0 ">
                <label class="form-check-box">
                    <input type="radio" id="suggestSponsor" #suggestASponsor [disabled]="false" name="wheredidyouhear"
                        [checked]="  sponsorWizard ===   sponsorSearchWizardType.SearchByIDontHaveSponsor"
                        (click)="setSponsorWizard(  sponsorSearchWizardType.SearchByIDontHaveSponsor);searchBySuggestSponsors ? '' : resetVariable(  sponsorSearchWizardType.SearchByIDontHaveSponsor)">                    
                    <span class="label-text"></span>
                    <!-- sponsor--tooltip -->
                    <span tabindex="-1" (keyup.control.space)="suggestASponsor.click()" role="radio"
                        attr.aria-label="{{'checkout.I dont have a Sponsor.Please find one for me' | translate | translateKey}}"
                        (keyup.enter)="suggestASponsor.click()"
                        class="form-check-text">{{"checkout.I don't have a sponsor. Please find one for me" | translate | translateKey}}
                        <!-- <span popover="{{'enrollSponsor.I dont have a sponsor description' | translate | translateKey}}"
                            outsideClick="true" placement="top" container="body"
                            class="ico-help fa fa-question-circle-o font-size-18">
                        </span> -->
                    </span>
                </label>

            </div>
        </div>
    </div>
    <div></div>
    <div *ngFor="let sponsorSearchOption of sponsorSearchOptions;let i=index;">
        <!-- When 'I know my Sponsor's Information' option Selected Starts-->
        <div class="col-md-12 " *ngIf="sponsorSearchOption.id === sponsorSearchOptionType.SearchByIKnowSponsor">
            <div class="row ml-4" *ngIf="  sponsorWizard === sponsorSearchWizardType.SearchByIKnowSponsor">
                <div class="col-md-6 floatLabelContainer  mt-10 pl-0" id="fbopanelid">
                    <input id="fboid" tabindex="0" (keyup.enter)="searchSponsorWizardByFboId(referringFboId, fboid?.errors?.pattern)"
                        float-label
                        role="textbox" [(ngModel)]="referringFboId" (input)="disableFboIdOrName(false)"
                        contenteditable="true"
                        attr.aria-label="{{'enrollSponsor.Please Enter valid ID or Email' | translate | translateKey}}"
                        aria-required="true" class="form-control"
                        placeholder="{{'enrollSponsor.Please Enter valid ID or Email' | translate | translateKey}}" type="text"
                        maxlength="50"
                        pattern="(^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+.[a-zA-Z]{2,}$)|(^[0-9]*$)|(^[0-9]+-[0-9]+-[0-9]+-[0-9]*$)"
                        #fboid="ngModel" [ngClass]="{'sponsor-border-color': !referringFboId && !isSponsorOptional}">
                    <span class="error" *ngIf="!isSearchByName && errorMessage">{{  errorMessage}}
                    </span>
                    <span tabindex="0" class="error" *ngIf="referringFboId && sponsorNotFound">
                        {{'enrollSponsor.The Sponsor ID you provided could not be found. Please provide another ID.'| translate | translateKey}}
                    </span>
                    <span tabindex="0" class="error" *ngIf="referringFboId && !  isSponsorEligible">
                        {{'enrollSponsor.The Sponsor ID you provided is not eligible. Please provide another ID.'| translate | translateKey}}
                    </span>
                    <span tabindex="0" class="error" *ngIf="fboid.errors && fboid.errors.pattern">
                        {{'enrollSponsor.Please Enter valid ID or Email'| translate | translateKey}}
                    </span>
                </div>

                <!-- Search by name -->
                <div class="col-12 col-md-12 mt-10 py-3 pl-0 pr-4 search__search-name bold"> {{'checkout.Or Search by Name' | translate | translateKey}}</div>
                <span [hidden]="sponsorOption.id === sponsorSearchCriteria.ID"
                    *ngFor="let sponsorOption of sponsorFields"
                    [ngSwitch]="sponsorOption.id">
                    <div class="col-md-6 floatLabelContainer mt-10 pl-0"
                        *ngSwitchCase="sponsorSearchCriteria.FirstName">
                        <input tabindex="0"
                            (input)="trimValue($event);disableFboIdOrName(true)"
                            (keyup.enter)="searchSponsorByName(firstName,lastName,selectedSponsorCountry,selectedSponsorState)"
                            float-label attr.data-placeholder="{{'customer-service.First Name' + '*' | translate | translateKey}}"
                            role="textbox"
                            contenteditable="true"
                            [(ngModel)]="firstName"
                            attr.aria-label="{{'customer-service.First Name' | translate | translateKey}}"
                            aria-required="true"
                            class="form-control"
                            placeholder="{{'customer-service.First Name' + '*' | translate | translateKey}}"
                            type="text"
                            [class.error-label]="isFirstNameError">
                        <span class="col-12 error px-0 pb-2"
                            *ngIf="isFirstNameError">
                            {{'customer-service.Required'| translate | translateKey}}
                        </span>
                    </div>
                    <div class="col-md-6 floatLabelContainer form-group mt-10 pl-0"
                        *ngSwitchCase="sponsorSearchCriteria.LastName">
                        <input tabindex="0"
                            (input)="trimValue($event);disableFboIdOrName(true)"
                            (keyup.enter)="searchSponsorByName(firstName,lastName,selectedSponsorCountry,selectedSponsorState)"
                            float-label attr.data-placeholder="{{'customer-service.Last Name' + '*' | translate | translateKey}}"
                            role="textbox"
                            contenteditable="true"
                            [(ngModel)]="lastName"
                            attr.aria-label="{{'customer-service.Last Name' | translate | translateKey}}"
                            aria-required="true"
                            class="form-control"
                            placeholder="{{'customer-service.Last Name' + '*' | translate | translateKey}}"
                            type="text"
                            [class.error-label]="isLastNameError">
                        <span class="col-12 error px-0 pb-2"
                            *ngIf="isLastNameError">
                            {{'customer-service.Required'| translate | translateKey}}
                        </span>
                    </div>
                    
                    <div class="col-md-6 floatLabelContainer form-group mt-10 pl-0"
                        *ngSwitchCase="sponsorSearchCriteria.Country">
                        <select tabindex="0"
                                role="listbox"
                                float-label [(ngModel)]="selectedSponsorCountry"
                                (input)="onCountryChange($event.target.value)"
                                attr.data-placeholder="{{'customer-service.Country' | translate | translateKey}}"
                                class=" form-control "
                                name="position "
                                required>
                            <option [value]="country.countryId"
                                    [selected]="country.countryId == selectedSponsorCountry"
                                    *ngFor="let country of filteredTitanCountries | orderBy : 'name'">{{country.name}}</option>
                            <option disabled>──────────</option>
                            <option [value]="country.countryId"
                                    [selected]="country.countryId == selectedSponsorCountry"
                                    *ngFor="let country of filteredNonTitanCountries | orderBy : 'name'">{{country.name}}</option>
                        </select>
                    </div>
                    <div *ngSwitchCase="sponsorSearchCriteria.State">
                        <div class="col-md-6 floatLabelContainer form-group mt-10 pl-0"
                            *ngIf="showStates">
                            <select (input)="disableFboIdOrName(true)"
                                    role="listbox"
                                    tabindex="0"
                                    id="statelist"
                                    name="sponsorStateName"
                                    float-label attr.data-placeholder="{{'enrollSponsor.State or Province' | translate | translateKey}}"
                                    class=" form-control "
                                    name="position"
                                    [(ngModel)]="selectedSponsorState">
                                <option role="option"
                                        [value]="0">{{'customer-service.Select' | translate | translateKey}}</option>
                                <option role="option"
                                        [ngValue]="state.id"
                                        *ngFor="let state of states | orderBy : 'name'">{{state.stateName}}</option>
                            </select>
                        </div>
                    </div>
                </span>
                <div class="col-md-12 no-padding error px-0 pb-2" *ngIf="  noSponsorFound && !searchBySponsorError">
                    {{'enrollSponsor.No Sponsors available for the last search.'| translate | translateKey}}
                </div>
                <span class="col-md-12 no-padding error px-0 pb-2" *ngIf="searchBySponsorError">
                    {{'enrollSponsor.Please enter valid search criteria in any of the above options'| translate | translateKey}}.
                </span>
                
                <div class="error" *ngIf="!  noSponsorFound">
                    {{  sponsorErrorMessage}} </div>
                <div class="col-12 pl-0 selected-sponsor hide" *ngIf="selectedSponsor">
                    <div class="row col-12 border">
                        <div class="profile-pic list-inline-item col-3 m-0">
                            <img imgSrc="/images/no-photo.png" height="50" class="">

                        </div>
                        <div class="text-left col-9 font-weight-bold" tabindex="0">
                            <div>{{selectedSponsor.sponsorName}} </div>
                            <div class="label-text" *ngIf="selectedSponsor.address">
                                {{selectedSponsor.address.city}}
                                <span *ngIf="selectedSponsor.address && selectedSponsor.address.countryCode">,
                                    {{selectedSponsor.address.countryCode}}</span>
                            </div>

                            <i class="fa fa-check" aria-hidden="true"></i>
                        </div>

                    </div>
                    <div class="text-center py-2 font-weight-bold">
                        User selects FBO
                    </div>
                </div>
                <div class="sponsor-border w-100 mr-2 pr-8"
                    *ngIf="  searchByIDOrNameSponsors &&   searchByIDOrNameSponsors?.length>0 && !searchBySponsorError && !  noSponsorFound">
                    <div class="sponsorResults mt-0 slim-scroll" slimScroll width="100%" size="3px" height="inherit"
                        alwaysVisible="true" wheelStep="20" style="max-height: 200px; border: 1px solid #ccc;">
                        <div class="row sponsor__search-results"
                            *ngFor="let sponsor of   searchByIDOrNameSponsors;let i=index;">
                            <div class="col-12 col-md-7 px-2" tabindex="0">
                                <div class="col-1 px-2 col-md-1 custom-left-block-a">
                                    <input type="radio" tabindex="-1" name="iKnowSponsors"
                                        (click)="setSponsor(sponsor,i)"
                                        [checked]="(selectedSponsor && sponsor.sponsorId === selectedSponsor.sponsorId) || sponsor.isAutoSelect">
                                </div>
                                <div class="col-11 px-2 col-md-11 custom-right-block">
                                    <label class="form-check-box d-flex" tabindex="0"
                                        (keyup.enter)="setSponsor(sponsor,i)"
                                        attr.aria-label="{{'enrollSponsor.Click to select above sponsor' | translate | translateKey}}">

                                        <span class="label-text pt-4"></span>
                                        <span class="form-check-text d-inline-block">
                                            <div class="sponsor__search-results--title" *ngIf="sponsor">
                                                {{sponsor.sponsorId | distributorIdFormat}}
                                            </div>
                                            <div class="sponsor__search-results--sub-title"
                                                *ngIf="sponsor && sponsor.sponsorName">
                                                {{sponsor.sponsorName}} </div>
                                            <div class="sponsor__search-results--info">
                                                <span tabindex="0"
                                                    attr.aria-label="{{'common.Selected Sponsor City' | translate | translateKey}}"
                                                    *ngIf="sponsor && sponsor.sponsorCity">{{sponsor.sponsorCity}}</span><span
                                                    tabindex="-1"
                                                    attr.aria-label="{{'common.Selected Sponsor State' | translate | translateKey}}"
                                                    *ngIf="sponsor && sponsor.sponsorStateCode">,
                                                    {{sponsor.sponsorStateCode}}</span>
                                                <div tabindex="-1"
                                                    attr.aria-label="{{'common.Selected Sponsor Country' | translate | translateKey}}"
                                                    *ngIf="sponsor && sponsor.sponsorCountryCode">
                                                    {{sponsor.sponsorCountryCode}}</div>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error" *ngIf="sponsorInfoNotSelectedErr">
                    {{'enrollSponsor.You have not selected a sponsor'| translate | translateKey}}
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right pr-8 mb-10">
                    <button role="button" tabindex="0" (click)="searchSponsorByName(firstName,lastName,selectedSponsorCountry,selectedSponsorState)" class="btn blue-button mobile-width position-relative"
                        type="button">
                        {{'customer-service.Search' | translate | translateKey}}
                        <!-- Sponsor loading spinner start -->
                        <span *ngIf="isSponsorLoading" tabindex="0"
                            class="personal-info--email-info sponsor-loader">
                            <i class="fa fa-spinner"></i></span>
                        <!-- Sponsor loading spinner end -->
                    </button>
                </div>
            </div>
        </div>
        <!-- When 'I know my Sponsor's Information' option Selected Ends-->
        <div class="col-md-12 " *ngIf="sponsorSearchOption.id === sponsorSearchOptionType.SearchByIDontHaveSponsor && selectedOrderType !== orderType.NEW_GUEST_RETAIL">
            <div class="row mt-10 ml-4" *ngIf="sponsorWizard === sponsorSearchWizardType.SearchByIDontHaveSponsor">
                <form class="col-12 pl-0 sponsor-selection row" novalidate [formGroup]="suggestSponsorForm"
                    (ngSubmit)="suggestSponsor(  suggestSponsorForm,   suggestSponsorForm.valid)">
                    <span class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-0"
                        *ngFor="let sponsorOption of   sponsorFields" [ngSwitch]="sponsorOption.id">

                        <div class="mb-3 pl-0" *ngSwitchCase="sponsorSearchCriteria.City">
                            <div class="form-group floatLabelContainer">
                              <input tabindex="0" formControlName="sponsorCity" float-label 
                              (input)="cityFieldRequired = false;"
                                attr.data-placeholder="{{'customer-service.City' | translate | translateKey}}" role="textbox"
                                contenteditable="true" attr.aria-label="{{'customer-service.City' | translate | translateKey}}"
                                aria-required="true" class="form-control" placeholder="{{'customer-service.City' | translate | translateKey}}"
                                [ngClass]="{'sponsor-border-color': cityFieldRequired}" type="text" [disabled]="isFboNameEnabled">
                                <div>
                                    <span class="error" *ngIf="cityFieldRequired">
                                        {{'operating-country.City is required'| translate | translateKey}} </span>
                                </div> 
                            </div>
                          </div>

                        <div class="pl-0" *ngSwitchCase="  sponsorSearchCriteria.ZipCode">
                            <div class="form-group floatLabelContainer">
                                <input formControlName="sponsorZipcode" (input)="cityOrZipcodeerrMsg = false;"
                                    name="sponsorZip" float-label
                                    attr.data-placeholder="{{'customer-service.Zip Code' | translate | translateKey}}"
                                    role="textbox" contenteditable="true" [pattern]="zipPattern"
                                    attr.aria-label="{{'customer-service.Zip Code' | translate | translateKey}}"
                                    aria-required="false" class="form-control"
                                    placeholder="{{'customer-service.Zip Code' | translate | translateKey}}" 
                                    [ngClass]="{'sponsor-border-color': cityOrZipcodeerrMsg}" type="text">
                                <div class="error" *ngIf="cityOrZipcodeerrMsg">
                                    {{'operating-country.Zip Code is required'| translate | translateKey}}
                                </div>
                                <div *ngIf="(suggestSponsorForm.controls['sponsorZipcode'].touched || formSubmmitted)">
                                    <span class="error" *ngIf="sponsorZipcode.errors && sponsorZipcode.errors.pattern">
                                        {{'enrollSponsor.Please enter a valid zip code'| translate | translateKey}}
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="pl-0 mb-3" *ngSwitchCase="  sponsorSearchCriteria.Language">
                            <div class="form-group floatLabelContainer">
                                <select role="listbox" name="sponsorLanguageValue" formControlName="sponsorLanguage"
                                    float-label attr.data-placeholder="{{'customer-service.Language' | translate | translateKey}}"
                                    class=" form-control" name="position">
                                    <option role="option" [ngValue]="0" disabled selected>Language</option>
                                    <option role="option" [ngValue]="language.languageName"
                                        *ngFor="let language of   setLanguagesByCountry | orderBy : 'languageName'"
                                        [selected]="language.languageName ===   setSuggestLanguage">
                                        {{language.languageName}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="mb-3 pl-0" *ngSwitchCase="sponsorSearchCriteria.State">
                            <div class="form-group floatLabelContainer">
                                <select role="listbox"  formControlName="sponsorState" float-label attr.data-placeholder="{{'customer-service.State' | translate | translateKey}}" 
                                  class=" form-control" name="position">
                                  <option role="option" [ngValue]="0" selected>Select</option>
                                    <option role="option" [ngValue]="state.id" *ngFor="let state of states | orderBy : 'name'">{{state.stateName}}</option>
                                </select>
                                <div class="error" *ngIf="cityOrZipcodeerrMsg">
                                    {{'operating-country.State Or Province is required'| translate | translateKey}}
                                </div>
                            </div>  
                        </div>
                        <div class="mb-3 pl-0" *ngSwitchCase="sponsorSearchCriteria.Country">
                            <div class="form-group floatLabelContainer">
                                <select [attr.disabled] ="sponsorConfig && sponsorConfig.isSponsorSearchByArea" tabindex="0"
                                formControlName="sponsorCountry" role="listbox" float-label
                                    (input)="onCountryChange($event.target.value)"
                                    attr.data-placeholder="{{'checkout.Country' | translate | translateKey}}" class=" form-control "
                                    name="position">
                                    <option [value]="country.countryId"
                                        [selected]="country.countryId == countryId"
                                        *ngFor="let country of countries | orderBy : 'name'">{{country.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </span>

                    <div tabindex="0" class="col-12 error no-padding" *ngIf="  noSuggestSponsorFound">
                        {{'enrollSponsor.No Sponsors available for the last search.'| translate | translateKey}}
                    </div>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mb-10">
                        <button role="button" tabindex="0" class="btn blue-button mobile-width position-relative"
                            type="submit" [disabled]="!( setSuggestLanguage || setSuggestZipCode)">
                            {{'customer-service.Search' | translate | translateKey}}
                            <!-- Sponsor loading spinner start -->
                            <span *ngIf="  isSponsorLoading" tabindex="0"
                                class="personal-info--email-info sponsor-loader">
                                <i class="fa fa-spinner"></i></span>
                            <!-- Sponsor loading spinner end -->
                        </button>
                    </div>
                </form>
                <div class="sponsor-border w-100 mt-10 mb-10" *ngIf="searchBySuggestSponsors && suggestSponsorFound">
                    <div class="row sponsor__search-results mt-10"
                        *ngFor="let sponsor of  searchBySuggestSponsors;let i=index;">
                        <div class="col-md-6" tabindex="-1">
                            <div class="col-md-1 custom-left-block-b">
                                <input type="radio" tabindex="-1" name="suggestSponsors" (click)="setSponsor(sponsor,i)"
                                    [checked]="(selectedSponsor && sponsor.sponsorId === selectedSponsor.sponsorId) || sponsor.isAutoSelect">
                            </div>
                            <div class="col-md-11 custom-right-block">
                                <label class="form-check-box d-flex" tabindex="0" (keyup.enter)="setSponsor(sponsor,i)"
                                    attr.aria-label="{{'enrollSponsor.Click to select above sponsor' | translate | translateKey}}">

                                    <span class="label-text pt-4"></span>
                                    <span class="form-check-text d-inline-block">
                                        <div class="sponsor__search-results--title" *ngIf="sponsor">
                                            {{sponsor.sponsorId| distributorIdFormat}} </div>
                                        <div class="sponsor__search-results--sub-title"
                                            *ngIf="sponsor && sponsor.sponsorName">
                                            {{sponsor.sponsorName}} </div>
                                        <div class="sponsor__search-results--info">
                                            <span tabindex="-1"
                                                attr.aria-label="{{'enrollSponsor.Selected Sponsor City' | translate | translateKey}}"
                                                *ngIf="sponsor && sponsor.sponsorCity">{{sponsor.sponsorCity}}</span><span
                                                *ngIf="sponsor && sponsor.sponsorCity && sponsor.sponsorStateCode">,</span>
                                            <span tabindex="-1"
                                                attr.aria-label="{{'enrollSponsor.Selected Sponsor State' | translate | translateKey}}"
                                                *ngIf="sponsor && sponsor.sponsorStateCode">{{sponsor.sponsorStateCode}}</span>
                                            <div tabindex="-1"
                                                attr.aria-label="{{'enrollSponsor.Selected Sponsor Country' | translate | translateKey}}"
                                                *ngIf="sponsor && sponsor.sponsorCountryCode">
                                                {{sponsor.sponsorCountryCode}}</div>
                                        </div>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/enrollment/sponsor-search.component.html